<template>
  <div id="connectUsPage"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="تماس با ما"></ActionBar>
    <div v-if="isLoaded" class="container">
      <div class="row">
        <img :src="$replaceHttps(pageDetail.FileUrl)" alt="بنر" class="img-fluid col-md-6 col-sm-10 col-12 mx-auto"
             @click="openLink(pageDetail.Link)">
      </div>
      <div class="row p-3 pt-0">
        <div
            class=" p-4 my-2 mx-auto rounded-xl  col-md-6 col-sm-10 col-12 mx-auto">
          <div v-html="pageDetail.Description">
          </div>
        </div>
      </div>
    </div>
    <FooterMenu/>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
let _this = null;
import ActionBar from "../components/ActionBar";
import FooterMenu from "../components/FooterMenu";

export default {
  name: "ConnectUs",
  metaInfo: {
    title: 'مسیربرتر-تماس با ما'
  },
  components: {FooterMenu, ActionBar},
  data: () => ({
    pageDetail: null,
    isLoaded: false,
    showLoaderDialog: false,
  }),
  mounted() {
    _this = this;
    this.getData()
  },
  methods: {
    getData() {
      this.showLoaderDialog= true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Publicly/ContactUs", requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.pageDetail = JSON.parse(result)
            _this.isLoaded = true
            _this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));

    },
    openLink(link){
      if(link !== null){
        this.$openLink(link)
      }
    }
  }
}
</script>
